<template>
    <div>    
        <div class="l-page-layout l-page-layout--two-column-fixed" style="overflow: hidden;">
        <div class="l-page-layout__secondary" style="overflow: hidden;">
        <div class="c-header-dark" role="banner">
            <div class="c-header-vertical__inner">
 
            <router-link to="/" tag="a" class="c-logo__link" exact-active-class="home-page-active">
              <div class="c-logo-vertical" style="float: left"> <!-- logo-container -->
                  <img class="header-image__container"  :src="imgPath + 'blbglogo.svg'"/>
              </div>
            </router-link><!--end c-logo__link-->    
            <a data-cy="logoutButton" id="logout-button">
                <img :src="imgPath + 'BLBG-icons/c-icon__account-circle.svg'"/>
                <div>
                  <span class="username">{{ currentUser }}</span>
                  <br>
                  <span style="display:inline;">
                    <span @click="logout" class="logout__link">logout</span> |
                    <span @click="userProfile" class="logout__link">account</span>
                </span>
                </div>
            </a><!-- end sublink -->

            <div 
              class="c-btn c-btn--small c-header-vertical__nav-btn js-nav-trigger" 
              style="background: none;" 
              @click="revealMenu()" 
              :class="{'is-active':(menuStyle=='drop')}">
                <svg class="c-icon--large" aria-hidden="true">
                    <use :href="imgPath + 'icons.svg#menu-hamburger'"></use>
                </svg>
             
            </div> <!--responsiveness toggle -->

            <div class="c-header-vertical__nav-container js-nav-panel">

                <nav class="c-primary-nav-vertical" role="navigation">
              
                <ul class="c-primary-nav-vertical__list js-nav-panel" role="tablist" aria-multiselectable="true">
                        

                    <li
                        v-for="(item,idx) in menuItems"
                        :id="`menu-item-${idx}`"
                        :key="`menu-item-${idx}`"
                        class="c-primary-nav-vertical__item"
                        :class="{'is-active':(item.hasChildren==false)}"
                    >
                        <span v-if="item.hasChildren==false">
                            <router-link
                                :to="item.redirectUrl"
                                tag="a"
                                class="c-primary-nav__link no-children"
                                exact
                                
                            >
                                <div class="c-icon--large red-on-active">
                                    <img :src="imgPath + item.img"/>
                                </div>
                                <span class="c-primary-nav__link red-on-active" >
                                    {{ item.title }}
                                </span>
                            </router-link>
                        </span>
                        <span v-else>
                            <a 
                                href="#" 
                                class="c-primary-nav-vertical__link--has-children js-nav-dropdown-trigger" 
                                role="button" 
                                tabindex="0" 
                                aria-expanded="false"
                            >
                                <div class="c-icon--large">
                                    <img :src="imgPath + item.img"/>
                                </div>
                                <span class="c-primary-nav__link" >{{ item.title }}</span>
                                <svg class="c-icon c-primary-nav-vertical__icon" aria-hidden="false">
                                    <use :href="imgPath + 'icons.svg#chevron-down'"></use>
                                </svg>
                            </a>
                            <!-- SubList -->
                            <ul class="c-primary-nav-vertical__sublist js-nav-dropdown">
                                <li v-for="(child,idx) in item.children" :key="`nav-link-${idx}`" >
                                    <router-link
                                        :to="child.redirectUrl"
                                        tag="a"
                                        class="c-primary-nav__link"
                                        exact
                                    >
                                        <span class="c-primary-nav__link red-on-active">{{ child.title }}</span>
                                    </router-link><!-- end sublink -->
                                </li><!-- end sublist item -->
                            </ul>
                        </span>
                    </li>

                </ul><!-- end c-nav__list -->

                </nav><!-- end c-nav -->

            </div><!--end c-header__nav-container-->
            
            <div 
              class="c-header-vertical__nav-container js-nav-panel smaller-header"  
              v-bind:class="{'show-header':(menuStyle==='drop')}"
            >

                <nav class="c-primary-nav-vertical" role="navigation">
       
                    <ul 
                      class="c-primary-nav-vertical__list js-nav-panel" 
                      role="tablist" 
                      aria-multiselectable="true"
                    >
                        <li class="c-primary-nav-vertical__item" @click="revealMenu()">
                            <span class="c-primary-nav__link">
                                <a @click="logout"  data-cy="logoutButton">
                                    <span class="logout__link">logout</span>
                                </a><!-- end sublink -->
                            </span>
                        </li>
                        <li 
                            v-for="(item,idx) in menuItems"
                            :key="`item-${idx}`"
                            class="c-primary-nav-vertical__item"
                            :class="{'is-active':(item.hasChildren==false)}"
                        >
                            <span v-if="item.hasChildren==false"  @click="revealMenu()">
                                <router-link
                                    :to="item.redirectUrl"
                                    tag="a"
                                    class="c-primary-nav__link no-children"
                                    exact
                                >
                                    <div class="c-icon--large red-on-active">
                                        <img :src="imgPath + item.img"/>
                                    </div>
                                    <span class="c-primary-nav__link red-on-active">
                                        {{ item.title }}
                                    </span>
                                </router-link>
                            </span>
                            <span v-else>
                                <a 
                                    href="#" 
                                    class="c-primary-nav-vertical__link--has-children js-nav-dropdown-trigger" 
                                    role="button" 
                                    tabindex="0" 
                                    aria-expanded="false"
                                >
                                    <div class="c-icon--large">
                                        <img :src="imgPath + item.img"/>
                                    </div>
                                    <span class="c-primary-nav__link">{{ item.title }}</span>
                                    <svg class="c-icon c-primary-nav-vertical__icon" aria-hidden="false">
                                        <use :href="imgPath + 'icons.svg#chevron-down'"></use>
                                    </svg>
                                </a>
                                <!-- SubList -->
                                <ul class="c-primary-nav-vertical__sublist js-nav-dropdown">
                                    <li v-for="(child,idx) in item.children" :key="`sublist-vertical-child-${idx}`" >
                                        <router-link
                                            :to="child.redirectUrl"
                                            tag="a"
                                            class="c-primary-nav__link"
                                            exact
                                            
                                        >
                                            <span class="c-primary-nav__link red-on-active" @click="revealMenu()">{{ child.title }}</span>
                                        </router-link><!-- end sublink -->
                                    </li><!-- end sublist item -->
                                </ul>
                            </span>
                        </li>

                    </ul><!-- end c-nav__list -->

                </nav><!-- end c-nav -->

            </div><!--end c-header__nav-container-->
            </div><!--end c-header__inner-->
        </div><!-- end secondary l-page column -->
        </div>
        </div><!-- end two column layout-->
    </div> 
  
</template>

<script>
export default {
    mounted () {
        this.toggleMenu()
    },
    computed:{
        currentUser(){
            return this.$store.state.user ? this.$store.state.user.username : this.fetchUserName()
        }
    },
    data(){
        return {
            menuStyle: 'hide',
            imgPath: process.env.IMAGES_PATH,
            page: window.location.href.split('/').pop(),
            menuItems: [
                { title: 'Cases', redirectUrl:'/cases', img:'BLBG-icons/c-icon__briefcase.svg', hasChildren: false},
                { title:'DOG Cases', redirectUrl:'/dogCases', img:'BLBG-icons/c-icon__dog.svg', hasChildren: false},
                { title:'Loss Calculator', img:'BLBG-icons/c-icon__calculator.svg', hasChildren: true,
                    children: [
                        {title: 'Calculator', redirectUrl: '/lossCalculator'},
                        {title: 'Loss Runs', redirectUrl:'/lossRuns'}
                    ]},
                //Required for PW-ETL
                { title: 'Clients', redirectUrl:'/clients', img:'BLBG-icons/c-icon__face.svg', hasChildren: false},
                { title: 'Delete Client', redirectUrl:'/clientDelete', img:'BLBG-icons/c-icon__face.svg', hasChildren: false},
                { title: 'Dockets', redirectUrl:'/dockets', img:'icon_docket.svg', hasChildren: false},
                { title: 'Motions', redirectUrl:'/motions', img:'BLBG-icons/c-icon__gavel.svg', hasChildren: false},
                { title: 'Calendar', redirectUrl:'/calendar', img:'BLBG-icons/c-icon__calendar.svg', hasChildren: false},
                { title: 'Trades & Holdings', img:'BLBG-icons/c-icon__line-chart.svg', hasChildren: true, children:[
                    {title:'Trades', redirectUrl:'/trades'},
                    {title:'Holdings', redirectUrl:'/holdings'},
                    {title:'DOG Holdings', redirectUrl:'/dogHoldings'}
                ]},
                {title: 'SEC 13-F Filings', img: 'icon_13f.svg', hasChildren: true, children: [
                    {title: '13-F Holdings', redirectUrl:'/13f/holdings'},
                     {title: '13-F Losses', redirectUrl:'/13f/losses'},
                ]
                },
                { title:'Analyses', redirectUrl:'/reports', img:'BLBG-icons/c-icon__document.svg', hasChildren: true, children:[
                    {title:'Security Price Drops', redirectUrl:'/securityDrops'},
                    {title:'Discrepancies', redirectUrl:'/discrepancy'}
                ]},
                { title: 'Client Management', redirectUrl: '/client-management', img:'BLBG-icons/c-icon__client-management.svg',
                    hasChildren: true, children: [
                        {title:'Reports', redirectUrl: '/client-management/reports'},
                        {title:'Report Generator', redirectUrl: '/client-management/reportGenerator'},
                        {title:'Client Portal News Feed', redirectUrl: '/client-management/news-feed'}
                    ]
                },
                { title:'Data Panel', img:'BLBG-icons/c-icon__admin-settings.svg', hasChildren: true, children:[
                    {title:'Accounts', redirectUrl:'/accounts'},
                    {title: 'Securities', redirectUrl:'/securities'},
                    {title: 'Securities Squash', redirectUrl:'/securitiesSquash'},
                    {title: 'SecuritiesIngestion', redirectUrl:'/securitiesIngestion'}
                ]},
                { title:'Help', img:'icon_home.svg', hasChildren: true, children:[
                    {title:'How To', redirectUrl:'/howto'}
                ]},
                { title:'Admin Panel', img:'BLBG-icons/c-icon__admin-settings.svg', hasChildren: true, children:[
                    {title:'Users & Privileges', redirectUrl:'/admin'},
                    //Required for PW-ETL
                    {title:'Ingestion Panel', redirectUrl:'/ingestion'}
                ]},
                { title: 'Transaction/Holding Search', redirectUrl:'/txnSearch', img:'BLBG-icons/c-search-icon.svg', hasChildren: false}
            ]
        }
    },
    methods: {
        async fetchUserName(){
            const claims = await this.$auth.getUser()
            return claims.name

        },
        revealMenu(){
            let expanded = document.querySelectorAll('[aria-expanded="true"]')
            this.menuStyle==="drop"? this.menuStyle="hide" : this.menuStyle="drop" 
            if(this.menuStyle==="hide"){               
                for (var i = 0; i < expanded.length; i++) {
                    expanded[i].parentNode.classList.remove('is-active')
                    expanded[i].setAttribute('aria-expanded', 'false')
                }
            } 
        },
        toggleMenu(){           
            function collapseArias() {
                var expanded = document.querySelectorAll('[aria-expanded="true"]')
                for (var i = 0; i < expanded.length; i++) {
                    expanded[i].parentNode.classList.remove('is-active');
                    expanded[i].setAttribute('aria-expanded', 'false')
                }
            }
            var navLink = document.querySelectorAll('.js-nav-dropdown-trigger'); /* 1 */
            for (var i = 0; i < navLink.length; i++) { /* 1 */

                if (navLink[i].nodeName != 'BUTTON') { /* 2 */
                    navLink[i].setAttribute('role', 'button');
                    navLink[i].setAttribute('tabindex', '0');

                    navLink[i].addEventListener('keypress', function(event) { /* 3 */
                                if (event.keyCode == 32) {
                                        event.preventDefault();
                                        this.click();
                                }
                    });
                }
                if (navLink[i].parentNode.classList.contains('is-active')) {  /* 4 */
                    navLink[i].setAttribute('aria-expanded','true');
                }
                else {
                    navLink[i].setAttribute('aria-expanded','false');
                }

                navLink[i].addEventListener('click', function(event) { /* 5 */
                    event.preventDefault();
                    var navLinkParent = this.parentNode; /* 5 */
                    if (navLinkParent.classList.contains('is-active')) { /* 6 */
                        navLinkParent.classList.remove('is-active');
                        this.setAttribute('aria-expanded', 'false');
                    }
                    else { /* 7 */
                        collapseArias()
                        navLinkParent.classList.add('is-active');
                        this.setAttribute('aria-expanded', 'true');
                    }
                });
            }

            var navNoChildren = document.querySelectorAll('.no-children');
            for (var i = 0; i < navNoChildren.length; i++) {
                navNoChildren[i].addEventListener('click', function(event) {
                    event.preventDefault();
                    collapseArias();
                });
            }
        },
        userProfile(){
            this.$router.push('/userProfile')
        },
        logout() {
            this.$store.dispatch('logout')
        }
    }
}
</script>

<style scoped lang="scss">
    
.c-header-vertical__inner {
  padding: 15px;
  min-width: 200px;
}

.c-header-vertical__nav-container.js-nav-panel {
    margin-top: 3rem;
} 

.smaller-header {
    display: none;
}

.c-primary-nav__link:hover {
    color:#EE3224
}

.c-primary-nav-vertical__icon {
    transition-duration: 0.5s;
    float: right;
}

.c-logo-vertical {
    margin: 0rem;
    display: flex;
    justify-content: center;
}

/* li :matches(span, a) {
  padding: 0 !important;
  margin: 0 !important;
} */

.c-primary-nav__link {
  margin-top: 0;
}

.c-primary-nav__link:hover {
    color:#EE3224
}

.c-primary-nav-vertical__icon {
    transition-duration: 0.5s;
    float: right;
    /* padding: 8px 1.5rem 0 auto; */
}

/* extra selectors for safety */
.is-active .c-primary-nav-vertical__link--has-children .c-primary-nav-vertical__icon { 
    // fill: #EE3224; -- the color on the chevron now looks out-of-place to me
    transform: none; //unrotating the chevron
}

.router-link-active .red-on-active {
    color: #EE3224;
}

.home-page-active ~ div #menu-item-0 {
    .red-on-active {
        color: #EE3224
    }
}


.c-primary-nav-vertical__item {
    font-size: 115% ;
    // line-height: 2.5;
    max-width: 100%;
    min-width: 100%;
    margin: 0;
    a {
      display: flex;
      align-items: center;
      height: 2.5rem;
    }
}

.c-primary-nav-vertical__sublist {
    margin-left: 2.5rem;
}

.c-icon {
    min-height: 13px;
    min-width: 13px;
}

.c-icon--large {
    transform: none;
    float: left;
    /* margin-left: 1rem;
    margin-top: 0.25rem; */
}

.c-icon--large.red-on-active img {
    height: 1.25rem;
    width: 1.25rem;
}

.c-logo__img {
    margin-bottom: 2rem;
    padding: 0;
}

.temp-logo { 
    font-size: 50px;
    padding: 1rem 0rem;
    margin: 1rem 0rem;
}

.c-header-vertical__nav-container {
    width: 100%;
}

.shorten-header {
    max-height: 80vh;
}


.blbg-header-vertical__inner {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0;
    padding-top: 0 
} 

#logout-button {
  margin-top: 20px;
  display: flex;
  align-items: center;
  div:nth-child(2) {
    margin-left: 10px;
  }
}

.user-circle {
    height: 37px;
    width: 37px;
    background-color: #EE3224;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.user-circle--inner {
    text-align: center;
    margin: 0 auto;
    display: inline;
    vertical-align: middle;
}

.logout__link {
    font-size: 11px;
    line-height: 12px;
    text-align: center;
    letter-spacing: 0.02em;
    text-decoration-line: underline;
    color: #EE3224;
    padding-top: 0;
    margin-top: 0;
    margin-top: -1rem;
    margin-bottom: 1rem;
    text-transform: uppercase;
}

.logout__link:hover {
    cursor: pointer;
}

.logout__item {
    display: flex;
    flex-direction: column;
}

.logout__container {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 1rem;
}
.watermark {
    font-size: 13px;
    margin-left: 5px;
}

.username {
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #F2F2F2;
}

.c-primary-nav__link {
    font-size: 13px;
}

.c-primary-nav__link, .c-primary-nav-vertical {
    padding: 0;
    margin: 0;
}

span.c-primary-nav__link {
    margin-left: 10px;
}

.c-primary-nav-vertical__link--has-children {
  display: initial;
}

// MEDIA QUERIES
@media (min-width: 62em) {
    .show-header {
        display: none;
    }
}

@media (max-width: 62em) {
    .show-header {
        display: block;
    }
    .c-primary-nav-vertical__link--has-children {
        max-width: 15rem;
    }

    .c-primary-nav__link {
        width: auto;
    }

    .js-nav-panel {
        margin-top: 0;
    }
    .c-primary-nav-vertical__item {
        // line-height: 2rem;
        min-width: 16vw;
        a {
          height: 2.5rem;
        }

    }
    .c-header-dark {
        position: fixed;
        width: 100%;
        z-index: 15;
    }
    .c-header-vertical__inner {
        display: block;
    }

    .c-header-vertical__nav-btn {   
        float: right;
    }

}

</style>
